import { useQuery } from '@tanstack/react-query';

import { nudgesQueryOptions } from '../queries';

type UseProductNudge = {
  enabled?: boolean;
  productIds: number[];
};
export function useProductNudge({
  enabled = false,
  productIds,
}: UseProductNudge) {
  return useQuery({
    ...nudgesQueryOptions(productIds),
    enabled: !!productIds?.length && enabled,
  });
}
